import { z } from "zod";
import { DTOWorkspace } from "./workspace";
import { User, WorkspaceRoleSchema } from "@supernova-studio/model";

//
// Read
//

export const DTOWorkspaceRole = z.enum(["Owner", "Admin", "Creator", "Viewer", "Billing", "Contributor"]);

export const DTOUserWorkspaceMembership = z.object({
  // Workspace the user is a member of
  workspace: DTOWorkspace,

  // Assigned role the user has in the workspace
  role: DTOWorkspaceRole,

  // Role that determines actual permissions the user has in the workspace
  // E.g. this is different from the default role when editors are downgraded to viewers
  // when a workspace's subscription is downgraded to free tier
  effectiveRole: DTOWorkspaceRole,
});

export const DTOWorkspaceMember = z.object({
  user: User,
  role: WorkspaceRoleSchema,
  effectiveRole: WorkspaceRoleSchema,
});

export const DTOUserWorkspaceMembershipsResponse = z.object({
  membership: z.array(DTOUserWorkspaceMembership),
});

export const DTOWorkspaceMembersListResponse = z.object({
  members: z.array(DTOWorkspaceMember),
});

export type DTOWorkspaceRole = z.infer<typeof DTOWorkspaceRole>;
export type DTOUserWorkspaceMembership = z.infer<typeof DTOUserWorkspaceMembership>;
export type DTOUserWorkspaceMembershipsResponse = z.infer<typeof DTOUserWorkspaceMembershipsResponse>;
export type DTOWorkspaceMembersListResponse = z.infer<typeof DTOWorkspaceMembersListResponse>;
